import { UIColors } from './colors'

/*
 * Modify common styles on Nivo charts components
 *
 */

export default {
  axis: {
    textColor: UIColors.tickColor,
    fontSize: '16px',
    tickColor: UIColors.tickColor,
    legendColor: UIColors.legendColor,
    legendFontSize: '11px',
  },
  grid: {
    stroke: '#ddd',
    strokeWidth: 1,
    strokeDasharray: '',
  },
  markers: {
    lineColor: '#000',
    lineStrokeWidth: 1,
    textColor: '#000',
    fontSize: '11px',
  },
  dots: {
    textColor: '#000',
    fontSize: '11px',
  },
  tooltip: {
    container: {
      background: 'white',
      color: 'inherit',
      fontSize: 'inherit',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
      padding: '5px 9px',
    },
    basic: {
      whiteSpace: 'pre',
      display: 'flex',
      alignItems: 'center',
    },
    table: {},
    tableCell: {
      padding: '3px 5px',
    },
  },
  labels: {
    textColor: '#000',
  },
  sankey: {
    label: {},
  },
}
